import { matchPath } from 'react-router';
import { combineReducers } from 'redux';

import { SALES, TECHNICIAN, PARTS } from 'constants/ModeConstants';
import { PARTS_REMINDER, REMINDER } from 'constants/ModuleConstants';
import { PATH } from 'constants/RoutesConstants';

import error from 'modules/global/reducers/generic.error';
import { addMany } from 'modules/global/reducers/generic.ids';
import loading from 'modules/global/reducers/generic.loading';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import {
  FETCH_INTERVENTIONS_REQUEST,
  INIT_DASHBOARD,
  FETCH_INTERVENTIONS_STATUS_REQUEST,
  FETCH_INTERVENTIONS_STATUS_SUCCESS,
  FETCH_INTERVENTIONS_SUCCESS,
} from 'modules/interventions/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { createReducer } from 'utils/ReduxUtils';

/**
 * @param {string} pathname
 * @returns {"TECHNICIAN" | "SALES" | "REMINDER" | "PARTS" | 'PARTS_REMINDER'}
 */
const getModeFromPathname = pathname => {
  const CONFIG = {
    [SALES]: [PATH.SALES],
    [PARTS]: [PATH.PARTS],
    [REMINDER]: [PATH.REMINDERS],
    [PARTS_REMINDER]: [PATH.PARTS_REMINDER],
    [TECHNICIAN]: [PATH.AFTERSALES, PATH.BODYWORKS, PATH.SELF_SERVICE_KANBAN],
  };

  const [mode] =
    Object.entries(CONFIG).find(([, paths]) => paths.some(currentPath => matchPath(currentPath.path, pathname))) ?? [];
  return mode;
};

export default createSearchReducers(FETCH_INTERVENTIONS_REQUEST, {
  global: { matcher: ({ meta }) => meta?.source === 'dashboard' },
  ids: createReducer([], {
    [FETCH_INTERVENTIONS_SUCCESS]: (state, action) => {
      if (action.meta?.source === 'dashboard') {
        return addMany()(state, action);
      }
      return state;
    },
  }),
}, {
  mode: createReducer(null, {
    [INIT_DASHBOARD]: (state, { payload }) => payload.mode ?? state,
    [LOCATION_CHANGE]: (state, action) => getModeFromPathname(action.payload.location.pathname) || state,
  }),
  module: createReducer(null, {
    [INIT_DASHBOARD]: (_, { payload }) => payload.module ?? null,
  }),
  selectedInterventionId: createReducer(null, {
    [LOCATION_CHANGE]: (state, { payload }) => (payload.action === 'REPLACE' ? state : null),
  }),
  apiError: error(FETCH_INTERVENTIONS_REQUEST, {
    reducers: {
      [LOCATION_CHANGE]: () => null,
    }
  }),
  status: combineReducers({
    loading: loading(FETCH_INTERVENTIONS_STATUS_REQUEST),
    error: error(FETCH_INTERVENTIONS_STATUS_REQUEST),
    data: createReducer([], {
      [FETCH_INTERVENTIONS_STATUS_SUCCESS]: (_, { payload }) => payload,
    }),
  }),
});
